import { HealthHistoryEnum } from "components/Signup/store/state/types";

export type PreviousInjuriesItem = {
  title: string;
  text: string;
  id: HealthHistoryEnum;
  overviewText: string;
  disabled: (ids: HealthHistoryEnum[]) => boolean;
};

export const previousInjuriesItems: Array<PreviousInjuriesItem> = [
  {
    title: "signup.previous_injuries.item_1.title",
    text: "signup.previous_injuries.item_1.text",
    id: HealthHistoryEnum.NO_ILLNESS,
    overviewText: "signup.previous_injuries.item_1.overviewText",
    disabled: (selectedIds) =>
      selectedIds.some((id) =>
        [
          HealthHistoryEnum.TREATED_LAST_24_MONTHS,
          HealthHistoryEnum.ILLNESS_LAST_24_MONTHS,
          HealthHistoryEnum.CHRONIC_DISEASE,
        ].includes(id)
      ),
  },
  {
    title: "signup.previous_injuries.item_2.title",
    text: "signup.previous_injuries.item_2.text",
    id: HealthHistoryEnum.IMPORTED,
    overviewText: "signup.previous_injuries.item_2.overviewText",
    disabled: () => false,
  },
  {
    title: "signup.previous_injuries.item_3.title",
    text: "signup.previous_injuries.item_3.text",
    id: HealthHistoryEnum.TREATED_LAST_24_MONTHS,
    overviewText: "signup.previous_injuries.item_3.overviewText",
    disabled: (selectedIds) =>
      selectedIds.includes(HealthHistoryEnum.NO_ILLNESS),
  },
  {
    title: "signup.previous_injuries.item_4.title",
    text: "signup.previous_injuries.item_4.text",
    id: HealthHistoryEnum.ILLNESS_LAST_24_MONTHS,
    overviewText: "signup.previous_injuries.item_4.overviewText",
    disabled: (selectedIds) =>
      selectedIds.includes(HealthHistoryEnum.NO_ILLNESS),
  },
  {
    title: "signup.previous_injuries.item_5.title",
    text: "signup.previous_injuries.item_5.text",
    id: HealthHistoryEnum.CHRONIC_DISEASE,
    overviewText: "signup.previous_injuries.item_5.overviewText",
    disabled: (selectedIds) =>
      selectedIds.includes(HealthHistoryEnum.NO_ILLNESS),
  },
];
